import React, { useEffect, useState } from 'react'
import { useParams, useNavigate, Link } from 'react-router-dom';
import { practiceAreas } from './data';
import { PaystackButton } from 'react-paystack';
import BgImage from "../../images/practiceArea/contract.jpeg"

const PracticeAreasDetails = () => {
  const { practiceAreaId } = useParams();
  const navigate = useNavigate();
  const practice = practiceAreas.flatMap(category => category.item).find(practice => practice.title.toLowerCase().replace(/\s+/g, '-') === practiceAreaId);

  const [selectedService, setSelectedService] = useState(null);

  const handleClick = (service) => {
    setSelectedService(service);
  };

  useEffect(() => {
    if (practiceAreas?.length > 0) {
      if (!practiceAreaId || !practiceAreas.flatMap(category => category.item).some(practice => practice.title.toLowerCase().replace(/\s+/g, '-') === practiceAreaId)) {
        navigate("/areas-of-practice");
      }
    }
  }, [practiceAreaId, navigate]);

  const publicKey = "pk_test_043a090c91a3279a4eaff9f6efc3fcd274ada0a7";
  const [email, setEmail] = useState("");
  const amount = 100000;
  const [mobileNumber, setMobileNumber] = useState("");
  const [city, setCity] = useState("");

  const isFormFilled = email && mobileNumber && city;

  const componentProps = {
    email,
    amount: amount * 100,
    metadata: {
      email,
      mobileNumber,
      city
    },
    publicKey,
    text: "Talk to our expert",
    onSuccess: () => alert("Payment successful"),
    onClose: () => alert("Payment closed"),
  };

  const handlePayment = () => {
    if (!isFormFilled) {
      alert("Please fill in all fields before proceeding.");
    }
  };

  return (
    <div className="workSans">
      <section
        className="relative h-[400px] md:h-[450px] flex items-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(5, 33, 55, 0.9), rgba(5, 33, 55, 0.9)), url(${BgImage})`,
        }}
      >
        <div className="container mx-auto px-6 md:px-12 text-white z-10">
          <h1 className="text-4xl md:text-5xl font-bold mb-3">{practice.title}</h1>

          <div className="flex items-center text-sm md:text-base space-x-2 mb-6">
            <Link to="/" className="text-blue-300 hover:underline">
              Home
            </Link>
            <span className="text-[#d11c1c] font-bold">»</span>
            <Link to="/areas-of-practice" className="text-blue-300 hover:underline">
              Practice Areas
            </Link>
            <span className="text-[#d11c1c] font-bold">»</span>
            <span className="text-white">{practice.title}</span>
          </div>

          <hr className="border-t border-white opacity-10 mb-6" />
          <p className="text-lg md:text-l mb-6">
            {practice.desc1}
          </p>

          <Link
            to="/book"
            className="inline-block bg-[#d11c1c] text-white text-xs md:text-sm font-semibold tracking-wide uppercase py-3 px-6 rounded-sm shadow hover:bg-[#b81616] transition"
          >
            Speak with a Senior Legal Consultant →
          </Link>
        </div>
      </section>
      <div className="md:flex justify-between items-start gap-4 px-[6%] md:px-[10%] my-[6%]">
        <div className="">
          <p className="pt-6 font-[500] text-[16px]">{practice.desc1}</p>
          <p className="pt-6 font-[500] text-[16px]">{practice.desc2}</p>
          <p className="pt-6 font-[500] text-[16px]">{practice.desc3}</p>
          <p className="pt-6 font-[500] text-[16px]">{practice.desc4}</p>
          <p className="pt-6 font-[500] text-[16px]">{practice.desc5}</p>
          <p className="pt-6 font-[500] text-[16px]">{practice.desc6}</p>
          <p className="pt-6 font-[500] text-[16px]">{practice.desc7}</p>
          <p className="pt-6 font-[500] text-[16px]">{practice.desc8}</p>
          <p className="pt-6 font-[500] text-[16px]">{practice.desc9}</p>
          <p className="pt-6 font-[500] text-[16px]">{practice.desc10}</p>
          <p className="pt-6 font-[500] text-[16px]">{practice.desc11}</p>
          <p className="pt-6 font-[500] text-[16px]">{practice.desc12}</p>
          <p className="pt-6 font-[500] text-[16px]">{practice.desc13}</p>
          {practice?.services?.length > 0 && (
            <>
              <p className="font-[600] text-[18px]">{practice.title} Services In Nigeria</p>
              <div className="container mx-auto p-6">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    {practice?.services?.map((service, index) => (
                      <button
                        key={index}
                        className="block text-left w-full p-2 border-b hover:bg-gray-100"
                        onClick={() => handleClick(service)}
                      >
                        {service.heading}
                      </button>
                    ))}
                  </div>
                  <div className="border p-4">
                    {selectedService ? (
                      <div>
                        <h3 className="text-xl font-semibold mb-2">{selectedService?.heading}</h3>
                        {selectedService?.desc?.map((paragraph, idx) => (
                          <p key={idx} className="mb-4">{paragraph}</p>
                        ))}
                      </div>
                    ) : (
                      <p>Select a service to see details</p>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        <div className="w-full">
          <div className="p-4 bg-white shadow-md rounded-md">
            <p className="font-extrabold text-[20px] text-center py-2">Consult an expert today!</p>
            <div className="my-2">
              <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full border border-gray-300 rounded-lg p-3 mt-3 focus:outline-none focus:ring-2 focus:ring-blue-500" />
              <input type="tel" placeholder="Mobile Number" value={mobileNumber} onChange={(e) => setMobileNumber(e.target.value)} className="w-full border border-gray-300 rounded-lg p-3 mt-3 focus:outline-none focus:ring-2 focus:ring-blue-500" />
              <input type="text" placeholder="City/Pincode" value={city} onChange={(e) => setCity(e.target.value)} className="w-full border border-gray-300 rounded-lg p-3 mt-3 focus:outline-none focus:ring-2 focus:ring-blue-500" />
              {isFormFilled ? (
                <PaystackButton className="w-full bg-blue-600 text-white p-3 rounded-lg mt-3 cursor-pointer" {...componentProps} />
              ) : (
                <button onClick={handlePayment} className="w-full bg-gray-400 text-white p-3 rounded-lg mt-3 cursor-not-allowed">
                  Talk to our expert
                </button>
              )}
            </div>
          </div>
          <div className="p-4 bg-white shadow-md rounded-md hidden md:block mt-4">
            <p className="font-medium text-[20px] text-blue-900 text-center py-2">Why Choose Lawberon Legals & Co?</p>
            <p>
              We continuously seek innovative ways to assist our
              clients in addressing critical legal challenges while also
              helping them discover new opportunities for business growth
              across various industries. Beyond being lawyers, we serve as trusted
              advisors throughout every stage of a business transaction.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PracticeAreasDetails;
